import React from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import { useFieldArray, Controller } from 'react-hook-form';
import { FaPlus, FaTimes, FaCloudUploadAlt } from 'react-icons/fa';
import Select from 'react-select';
import FormInput from '../../form/FormInput';
import { customStyles } from '../../../utils/selectUtils';

const StepExperience = ({ control, errors, lookupOptions }) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: "experiences"
    });

    return (
        <div className="animate-fade-in">
            <div className="d-flex justify-content-between align-items-center mb-4 border-bottom border-secondary pb-2">
                <h6 className="text-uppercase text-white fw-bold m-0">
                    <span className="text-danger border-start border-4 border-danger ps-3">Experiences</span>
                </h6>
                <Button 
                    variant="outline-danger" 
                    size="sm"
                    className="fw-bold px-3"
                    onClick={() => append({
                        directorProductionHouse: '', cityTown: '', projectType: null, projectName: '',
                        monthYear: '', talent: [], noOfCasting: '', telecastOnChannel: '',
                        typeOfGenres: [], referenceVideoLink: '', moreAboutExperience: '', attachmentFile: null
                    })}
                >
                    <FaPlus className="me-2" /> ADD EXPERIENCE
                </Button>
            </div>

            {fields.map((field, index) => (
                <Card key={field.id} className="bg-transparent border-secondary mb-4 p-3 position-relative" style={{ borderStyle: 'dashed' }}>
                    
                    {/* Delete button (X) on top-right */}
                    <button 
                        type="button"
                        className="btn-close btn-close-white position-absolute" 
                        style={{ top: '15px', right: '15px', padding: '0.5rem' }} 
                        onClick={() => remove(index)}
                    />

                    <Row className="mt-2">
                        <Col md={3}>
                            <FormInput 
                                name={`experiences.${index}.directorProductionHouse`} 
                                label="Director/Production House" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={3}>
                            <FormInput 
                                name={`experiences.${index}.cityTown`} 
                                label="City/Town" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label">Project Type</Form.Label>
                                <Controller
                                    name={`experiences.${index}.projectType`}
                                    control={control}
                                    render={({ field: { onChange, value, ref } }) => (
                                        <Select
                                            ref={ref}
                                            options={lookupOptions.projectType}
                                            value={lookupOptions.projectType?.find(opt => opt.value === value) || value || null}
                                            onChange={val => onChange(val)}
                                            placeholder="Select"
                                            styles={customStyles}
                                        />
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <FormInput 
                                name={`experiences.${index}.projectName`} 
                                label="Project Name" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={3}>
                            <FormInput 
                                name={`experiences.${index}.monthYear`} 
                                label="Month & Year" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={3}>
                           
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label text-white">Talent</Form.Label>
                                <Controller
                                    name={`experiences.${index}.talent`}
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isMulti
                                            options={lookupOptions.talent}
                                            styles={customStyles}
                                            placeholder="Select Talents"
                                        />
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <FormInput 
                                name={`experiences.${index}.noOfCasting`} 
                                label="No Of Casting" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={3}>
                            <FormInput 
                                name={`experiences.${index}.telecastOnChannel`} 
                                label="Telecast On Channel" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                    </Row>

                    <Row>
                        <Col md={4}>
                            {/* 👈 ✅ Updated from FormInput to Multiselect Dropdown using lookupOptions.typeOfGenres */}
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label text-white">Type Of Genres</Form.Label>
                                <Controller
                                    name={`experiences.${index}.typeOfGenres`}
                                    control={control}
                                    render={({ field }) => (
                                        <Select
                                            {...field}
                                            isMulti
                                            options={lookupOptions.typeOfGenres}
                                            styles={customStyles}
                                            placeholder="Select Genres"
                                        />
                                    )}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <FormInput 
                                name={`experiences.${index}.referenceVideoLink`} 
                                label="Your Reference Video Link (YouTube/Vimeo)" 
                                control={control} 
                                errors={errors} 
                            />
                        </Col>
                        <Col md={4}>
                            <Form.Group className="mb-4">
                                <Form.Label className="form-label">Choose file</Form.Label>
                                <Controller
                                    name={`experiences.${index}.attachmentFile`}
                                    control={control}
                                    render={({ field: { onChange, value } }) => (
                                        <div className="d-flex align-items-center bg-dark text-white rounded border border-secondary" style={{ overflow: 'hidden' }}>
                                            <span className="flex-grow-1 px-3 text-truncate small text-secondary">
                                                {value instanceof File ? value.name : (field.attachmentUrl ? "Attached File" : "Choose file")}
                                            </span>
                                            <label 
                                                htmlFor={`file-upload-${index}`} 
                                                className="btn btn-secondary m-0 rounded-0 px-4" 
                                                style={{ cursor: 'pointer' }}
                                            >
                                                Browse
                                            </label>
                                            <input 
                                                type="file" 
                                                id={`file-upload-${index}`} 
                                                className="d-none" 
                                                onChange={(e) => onChange(e.target.files[0])} 
                                            />
                                        </div>
                                    )}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <FormInput 
                                name={`experiences.${index}.moreAboutExperience`} 
                                label="More About Your Experience" 
                                control={control} 
                                errors={errors} 
                                as="textarea" 
                                rows={5}
                            />
                        </Col>
                    </Row>
                </Card>
            ))}

            {fields.length === 0 && (
                <div className="text-center text-secondary py-5 bg-dark rounded border border-secondary" style={{ borderStyle: 'dashed' }}>
                    No experience details added yet. Click "+ ADD EXPERIENCE" to begin.
                </div>
            )}
        </div>
    );
};

export default StepExperience;